const submitSubmissionRequest = async (form: any, option: { id: string, title: string, price: number }) => {
  const url = `${process.env.NEXT_PUBLIC_REDIRECT_URL}api/landing/subscription`;
  const data = { form, option };

  const props = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(response => {
      const success = response?.success || false;
      return {
        success,
      }
    })
    .catch(error => {
      // handle error
      // eslint-disable-next-line no-console
      console.error(error);
      return {
        success: false,
      }
    });
  return props;
}

export default submitSubmissionRequest;